import { doc, writeBatch, setDoc, serverTimestamp } from "../config/dataClient";
import { isLocalPreview } from "../config/previewMode";
import { db } from "../config/firebase";
import { APP_ID } from "../config/constants";

export async function registerNotificationContact(user) {
  if (!user.email || !user.emailVerified) return;
  const email = user.email.toLowerCase();
  const batch = writeBatch(db);
  for (const id of [`uid-${user.uid}`, `email-${email}`]) {
    batch.set(doc(db, "artifacts", APP_ID, "public", "data", "notification_contacts", id), {
      uid: user.uid, email,
    });
  }
  await batch.commit();
}

export async function sendLeaveNotification(user, leaveId, event) {
  if (isLocalPreview) {
    await setDoc(doc(db, "artifacts", APP_ID, "public", "data", "notification_deliveries", `${leaveId}-${event}`), {
      leaveId, event, status: "preview", updatedAt: serverTimestamp(), ownerUid: user.uid,
    });
    return { status: "preview" };
  }
  await registerNotificationContact(user);
  const token = await user.getIdToken();
  const response = await fetch("/api/leave-notification", {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    body: JSON.stringify({ leaveId, event }),
  });
  if (!response.ok) {
    const result = await response.json().catch(() => ({}));
    throw new Error(result.error || "寄信服務無法使用，請聯絡管理員");
  }
  return response.json();
}
